import css from 'styled-jsx/css';

const styles = css.global`#carros-eletricos-economia {
  display: flex;
  padding: 40px 0 0 0;
  background-color: #F5F9FB;
}

#carros-eletricos-economia .ctn {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding-bottom: 60px;
  overflow: hidden;
}

.carros-eletricos-economia-title {
  font-family: 'SantanderHeadline';
  font-size: 24px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0em;
  color: #444;
  margin: 0;
  margin-bottom: 24px;
  width: 217px;
  text-align: center;
}

.carros-eletricos-economia-title .strong {
  font-weight: 800!important;
  /* color: #cc0000; */
}

.carros-eletricos-economia-subtitle {
  font-family: 'SantanderHeadline';
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
  color: #444;
  margin: 0;
  width: 274px;
  text-align: center;
}

.carros-eletricos-economia-subtitle b {
  font-weight: 600!important;
}

.carros-eletricos-economia-simule {
  font-family: 'SantanderText';
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
  color: #cc0000;
  margin: 0;
  margin-bottom: 22px;
  width: 274px;
  text-align: center;
}

.carros-eletricos-economia-simule b {
  font-weight: 600!important;
}

.carros-eletricos-economia-simulacao {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 21px;
  margin-bottom: 14px;
}

.carros-eletricos-economia-dados {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
  max-width: 90%;
}

.carros-eletricos-economia-valores {
  display: flex;
  flex-direction: column;
  /* gap: 30px; */
}

.carros-eletricos-economia-valores-input-div {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 10px;
}

.carros-eletricos-economia-valores-input-prices {
  display: flex;
  flex-direction: column;
}

.carros-eletricos-economia-valores-input-div-title {
  font-family: 'SantanderText';
  font-size: 16px;
  font-weight: 400;
  line-height: 40px;
  letter-spacing: 0px;
  color: #444444;
}

.carros-eletricos-economia-valores-input-mark-1 {
  position: absolute;
  right: 0;
  top: 12px;
  font-family: 'SantanderMicroText';
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0px;
  color: #444444;
}

.custom-range-slider {
  position: relative;
  display: flex;
  gap: 10px;
  flex-direction: column;
  width: 100%;
  font-family: 'SantanderMicroText';
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0px;
  color: #444444;
}

[type='range'] {
  position: relative;
  appearance: none;
  display: block;
  background-color: #767676;
  height: 2px;
  border-radius: 2px;
}

[type='range']::before,
[type='range']::after {
  position: absolute;
  display: inline-block;
}

[type='range']::-webkit-slider-thumb {
  appearance: none;
  display: block;
  width: 16px;
  height: 16px;
  border-radius: 16px;
  background-color: #cc0000;
  border: none;
}

[type='range']::-moz-range-thumb {
  appearance: none;
  display: block;
  width: 16px;
  height: 16px;
  border-radius: 16px;
  background-color: #cc0000;
  border: none;
}

/* input[type='range']::-moz-range-progress {
  display: block;
  appearance: none;
  background-color: #cc0000;
  height: 2px;
} */

.carros-eletricos-economia-resultado {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.carros-eletricos-economia-div {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 4px;
  padding: 17px 16px 16px 16px;
  height: 121px;
  background: #fff;
}

.carros-eletricos-economia-div.combustivel {
  border: 1px solid #444;
  color: #444;
}

.carros-eletricos-economia-div.eletrico {
  border: 1px solid #739E41;
  color: #444;
}

.carros-eletricos-economia-result-type,
.carros-eletricos-economia-result-price {
  font-family: 'SantanderText';
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0px;
  text-align: left;
  display: flex;
}
.carros-eletricos-economia-result-type img {
  margin-left: 10px;
}

.carros-eletricos-economia-result-price b {
  font-size: 24px;
  font-weight: 600 !important;
}

.carros-eletricos-economia-div.eletrico .carros-eletricos-economia-result-price b {
  color: #739E41;
}

.carros-eletricos-economia-result-text {
  font-family: 'SantanderHeadline';
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0px;
  text-align: left;

  color: #979797;
}

.carros-eletricos-economia-total {
  display: flex;
  width: 90%;
}

.carros-eletricos-economia-total-card-ctn {
  display: flex;
  width: 100%;
  height: fit-content;
  background-color: #DEEDF2;
  padding: 15px 27px 16px 21px;
  border-radius: 4px;
}

.carros-eletricos-economia-total-card {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.carros-eletricos-economia-total-title {
  display: flex;
  align-items: center;
  gap: 5px;
  font-family: 'SantanderHeadline';
  font-size: 24px;
  font-weight: 400;
  line-height: 34px;
  letter-spacing: 0px;
  text-align: left;
  color: #222222;
  margin: 0;
  margin-bottom: 16px;
}

.carros-eletricos-economia-total-text {
  font-family: 'SantanderHeadline';
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
  color: #222222;
  /* width: 200px; */
  align-self: flex-start;
  margin: 0;
}

.carros-eletricos-economia-total-result {
  width: 100%;
  background-color: #ffffff;
  border: 1px solid #767676;
  border-radius: 4px;
  font-family: 'SantanderText';
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0px;
  text-align: left;
  color: #222222;
  margin: 12px 0;
  padding-left: 16px;
  padding-top: 8px;
  padding: 0;
  max-width: 300px;
  height: 48px;
}

.carros-eletricos-economia-total-result-value {
  padding-left: 16px;
  padding-top: 8px;
  font-weight: 600;
}

.carros-eletricos-economia-total-anual {
  font-family: 'SantanderText';
  font-size: 24px;
  font-weight: 400;
  letter-spacing: 0px;
  text-align: left;
  color: #222222;
  align-self: flex-start;
  margin-top: 24px;
}

.carros-eletricos-economia-total-img {
  display: none;
}

.carros-eletricos-economia-media {
  font-family: 'SantanderHeadline';
  font-size: 16px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
  color: #767676;
}

.carros-eletricos-economia-circles-mb {
  position: absolute;
  bottom: 0;
  right: 0px;
  background-image: url('assets/carros-eletricos/circles-economia-mobile.png'), url('assets/carros-eletricos/circles-economia-mobile.webp');
  width: 87px;
  height: 41px;
  background-repeat: no-repeat;
}

.carros-eletricos-economia-circles-ds {
  display: none;
}

.input-relative {
  width: 100%;
  position: relative;
  margin: 0;
  padding: 0;
}

.input-relative input {
  margin: 0;
  width: 100%;
  outline: none;
}

.input-relative .slider-fill {
  height: 3px;
  width: 100%;

  display: block;
  margin: 0;
  padding: 0;
  pointer-events: none;
  position: absolute;
  left: 0;
  top: 0;
  transform: translate(0, -20%);
  z-index: 1;
  background-color: #cc0000;
}

@media (min-width: 992px) {
  #carros-eletricos-economia {
    display: flex;
    padding: 89px 0 0 0;
    overflow: hidden;
  }

  #carros-eletricos-economia .ctn {
    align-items: center;
    padding-bottom: 100px;
    overflow: visible;
  }

  .carros-eletricos-economia-title {
    font-size: 32px;
    font-weight: 400;
    line-height: 40px;
    text-align: center;
    width: 100%;
    margin-bottom: 24px;
  }

  .carros-eletricos-economia-title .strong,
  .carros-eletricos-economia-title .strong-desk {
    font-weight: 800!important;
  }

  .carros-eletricos-economia-subtitle {
    width: 100%;
  }

  .carros-eletricos-economia-simule {
    width: 100%;
  }

  .carros-eletricos-economia-subtitle {
    font-size: 24px;
    font-weight: 400;
    line-height: 40px;
    text-align: center;
    margin-bottom: 0px;
  }

  .carros-eletricos-economia-simule {
    font-size: 24px;
    font-weight: 400;
    line-height: 40px;
    text-align: center;
    width: 100%;
    margin-bottom: 0;
  }

   .carros-eletricos-economia-simulacao {
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    margin-top: 39px;
    gap: 62px
  }

  .carros-eletricos-economia-dados {
    max-width: 50%;
    gap: 47px;
  }

  .carros-eletricos-economia-valores {
    gap: 53px;
  }

  .carros-eletricos-economia-valores-input-prices {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 55px;
  }

  .carros-eletricos-economia-valores-input-prices .carros-eletricos-economia-valores-input-div {
    flex: 1;
  }

  .carros-eletricos-economia-valores-input-div-title {
    text-align: start;
    font-size: 20px;
  }

  .carros-eletricos-economia-resultado {
    flex-direction: row;
    gap: 36px;
  }

  .carros-eletricos-economia-div {
    flex: 1;
  }

  .carros-eletricos-economia-total {
    gap: 15px;
    align-items: flex-end;
  }

  .carros-eletricos-economia-total-card-ctn {
    width: 607px;
    height: 377px;
    padding: 0 0 0 32px;
    margin-top: 35px;
    align-items: center;
  }

  .carros-eletricos-economia-total-title {
    font-size: 28px;
    font-weight: 400;
    line-height: 34px;
    margin-bottom: 27px;
  }

  .carros-eletricos-economia-total-text {
    font-size: 18px;
    font-weight: 400;
    line-height: 28px;
    width: 225px;
  }

  .carros-eletricos-economia-total-anual {
    font-size: 18px;
    margin-top: 40px;
  }

  .carros-eletricos-economia-total-result {
    font-size: 24px;
    font-weight: 700;
    line-height: 36px;
    margin-top: 8px;
    width: 232px;
  }

  .carros-eletricos-economia-total-img {
    display: flex;
    width: 277px;
    height: 289px;
    object-fit: cover;
  }

  .carros-eletricos-economia-media {
    margin-top: 10px;
    align-self: flex-start;
    font-size: 18px;
    line-height: 27px;
  }

  .carros-eletricos-economia-circles-mb {
    position: absolute;
    top: 0;
    left: -179px;
    background-image: url(assets/carros-eletricos/circles-economia-desktop.png), url(assets/carros-eletricos/circles-economia-desktop.webp);
    width: 189px;
    height: 99px;
    background-repeat: no-repeat;
    transform: rotate(90deg);
  }

  .carros-eletricos-economia-circles-ds {
    display: flex;
    position: absolute;
    bottom: 0;
    right: -80px;
    background-image: url('assets/carros-eletricos/circles-economia-desktop.png'), url('assets/carros-eletricos/circles-economia-desktop.webp');
    width: 299px;
    height: 99px;
    background-repeat: no-repeat;
  }
}
`;

export default styles;